import {DetalhamentoApiService} from './../../service/api/detalhamento.api';
import {Component, OnInit, ViewChild, HostListener} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Message} from 'primeng/api';
import {Evento, FTA, SubfluxoPossivel} from '../../model/catalogo';
import {CatalogoApiService} from '../../service/api/catalogo.api';
import {ConstantesApiService} from '../../service/api/constantes.api';
import {UtilApi} from '../../service/api/util.api';
import {FtaService} from '../../service/fta.service';
import {ToadMensagemService} from './../../service/toad-mensagem.service';
import {FormataCalendario} from './../pipe/formata-calendario';
import {Router, ActivatedRoute} from '@angular/router';
import {GlobalService} from '../../service/global.service';
import {JQueryStatic} from 'jquery';
import {TipoEstado, TipoTemplate} from '../../model/constantes';
import {ModalService} from '../../service/modal.service';
import {ValidacaoService} from '../../service/validacao.service';

declare var $: JQueryStatic;

@Component({
    selector: 'fluxo-cliente-interno-completo',
    templateUrl: './fluxo-cliente-interno-completo.html',
    styleUrls: ['./fluxo-cliente-interno-completo.css'],
    providers: [ValidacaoService],
})
export class FluxoClienteInternoCompletoComponent implements OnInit {
    @ViewChild('formFta') public form: NgForm;

    fta: FTA = new FTA();

    fluxoVigente: boolean;

    subfluxoVigente: number;

    subfluxoPossivel: SubfluxoPossivel = new SubfluxoPossivel();

    listaFluxos: Array<FTA> = new Array<FTA>();

    chaveComposta: any;

    alias: string;

    prioridadeExecucao: string;

    orientacaoDoFluxo: string;

    grupoDesc: String;

    listaGrupo = [];

    listaSubFluxos: Array<SubfluxoPossivel> = new Array<SubfluxoPossivel>();

    evento: Evento = new Evento();

    eventos = [];

    lista = [];

    msgs: Message[] = [];

    loading: boolean = false;

    checked: boolean = false;

    date: Date;

    pt: any;

    sub: any;

    codigoFTA: number;

    versaoFTA: number;

    isCopiaFTA: string;

    controleInputVersao: boolean;
    controleInputFta: boolean;

    modelos: Array<TipoTemplate> = new Array<TipoTemplate>();

    estados: Array<TipoEstado> = new Array<TipoEstado>();

    constructor(
        public globalService: GlobalService,
        private ftaService: FtaService,
        private catalogoApi: CatalogoApiService,
        private messageService: ToadMensagemService,
        private utilApi: UtilApi,
        private constantesService: ConstantesApiService,
        private router: Router,
        private route: ActivatedRoute,
        private detalhamentoService: DetalhamentoApiService,
        private modalService: ModalService,
        private validacaoService: ValidacaoService
    ) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13) {
                if (
                    this.form.invalid == false &&
                    $('#modalEvento').hasClass('in') == false &&
                    $('#loginModal').hasClass('abrirModal') == false &&
                    !$('#descricao').is(':focus')
                ) {
                    this.salvar();
                } else if (
                    this.form.invalid == true &&
                    $('#modalEvento').hasClass('in') == false
                ) {
                }
            }
        }
    }

    ngOnInit() {
        this.recuperarModelos();

        this.carregarEstados();

        this.globalService.loading = false;
        this.pt = FormataCalendario.getCalendario();
        this.fta.eventos = [];
        this.codigoFTA = 0;
        this.versaoFTA = 0;
        this.controleInputVersao = true;
        //recupera parametros da rota
        this.sub = this.route.params.subscribe((params) => {
            this.codigoFTA = params['codigo'];
            this.versaoFTA = params['versao'];
            this.isCopiaFTA = params['copia'];
            let reload = params['reload'];
        });

        if (this.codigoFTA > 0 && this.versaoFTA > 0) {
            this.controleInputFta = true;
            this.recuperaFTA();
        } else {
            this.fta.versao = 1;
            this.addSubFluxoInit();
            this.listaGrupo.push({label: 1, value: 1});
        }

    }

    carregarEstados() {
        this.constantesService
            .buscaTipoEstado(0)
            .subscribe((estados) => (this.estados = estados as Array<TipoEstado>));
    }

    getEstado(codigo: number) {
        let estado = this.estados.find((x) => x.codigo == codigo);
        if (estado != null) {
            return estado;
        }
        return '-';
    }

    //monta combo de modelos
    recuperarModelos() {
        this.constantesService.buscaTipoModelo().subscribe((response) => {
            this.modelos = response.codigoTemplate;
        });
    }

    recuperaFTA() {
        this.globalService.loading = true;
        this.detalhamentoService
            .detalhaFta(this.codigoFTA, this.versaoFTA)
            .subscribe(
                (resposta) => {
                    this.fta = resposta as FTA;
                    this.ajustaFTAEdicao();
                },
                (erro) => {
                    this.globalService.loading = false;
                    this.exibirMensagemErro(`Erro ao recuperar o Fta.`);
                    return false;
                }
            );
    }

    ajustaFTAEdicao() {
        this.globalService.loading = false;

        this.listaSubFluxos = this.fta.subfluxoPossiveis;
        this.eventos = this.fta.eventos;

        if (this.listaSubFluxos.length > 0) {
            this.loading = true;
        }

        if (this.fta.contratoIed == 0) {
            this.fta.contratoIed = null;
        }

        let formatoIed = this.fta.formatoIed;
        if (formatoIed == 'null') {
            this.fta.formatoIed = null;
        }

        //adiciona todos os grupos de todos os eventos
        for (let i in this.fta.eventos) {
            if (this.fta.eventos[i].grupo.length > 0) {
                this.listaGrupo = this.fta.eventos[i].grupo;
            }
        }

        //remove grupos duplicados
        let listaGrupoAux = this.listaGrupo;
        this.listaGrupo = listaGrupoAux.filter(function (este, i) {
            return listaGrupoAux.indexOf(este) == i;
        });

        let listaGrupoAux2 = [];
        for (let i in this.listaGrupo) {
            listaGrupoAux2.push({
                label: this.listaGrupo[i],
                value: this.listaGrupo[i],
            });
        }
        this.listaGrupo = listaGrupoAux2;
    }

    // recupera do formulario faz um reset os campos
    onSubmit(f: NgForm) {
        if (this.checked == true) {
            this.fta.subfluxoVigente = this.checked
                ? f.value.nrSubfluxo
                : this.fta.subfluxoVigente;
        }

        this.subfluxoPossivel.nrSubfluxo = parseInt(f.value.nrSubfluxo);

        this.subfluxoPossivel.descricaoSubfluxo = f.value.descricaoSubfluxo;

        //this.subfluxoPossivel.vigente = this.checked ? "Sim" : "Não";

        this.listaSubFluxos.push(this.subfluxoPossivel);

        this.fta.subfluxoPossiveis = this.listaSubFluxos;

        this.subfluxoPossivel = new SubfluxoPossivel();

        f.reset();

        this.loading = true;
    }

    onSubmitGrupo(f: NgForm) {
        for (let i in this.listaGrupo) {
            if (this.listaGrupo[i].value == f.value.grupo) {
                this.messageService.addInfoKey(
                    'O grupo \'' + f.value.grupo + '\' já foi adicionado.',
                    this.chaveComposta
                );
                return;
            }
        }
        this.listaGrupo.push({label: f.value.grupo, value: f.value.grupo});
        this.grupoDesc = '';
        f.reset();
    }

    // método usado para remover do grupo
    removerGrupo(indice: any) {
        const index = this.listaGrupo.indexOf(indice);
        this.listaGrupo.splice(index, 1);
    }

    addSubFluxoInit() {
        this.loading = true;
        this.fta.subfluxoVigente = 1;
        this.subfluxoPossivel.nrSubfluxo = 1;
        this.subfluxoPossivel.descricaoSubfluxo = 'Fluxo Principal';
        this.listaSubFluxos.push(this.subfluxoPossivel);
        this.fta.subfluxoPossiveis = this.listaSubFluxos;
        this.subfluxoPossivel = new SubfluxoPossivel();
    }

    // edita subfluxoPossivel
    onRowSelect(item) {
        if (item.subfluxoVigente === item.nrSubfluxo) {
            this.checked = true;
        }

        this.fta.subfluxoVigente = this.checked
            ? item.nrSubfluxo
            : this.fta.subfluxoVigente;
        this.subfluxoPossivel.nrSubfluxo = item.nrSubfluxo;
        this.subfluxoPossivel.descricaoSubfluxo = item.descricaoSubfluxo;

        this.removerHeader(item);
    }

    // método usado para remover linha selecionada do subfluxo
    removerHeader(indice: any) {
        const index = this.listaSubFluxos.indexOf(indice);

        if (this.fta.subfluxoVigente === indice.nrSubfluxo) {
            this.fta.subfluxoVigente = null;
        }

        this.listaSubFluxos.splice(index, 1);

        if (this.listaSubFluxos.length === 0) {
            this.loading = false;
        }
    }

    // método usado para receber o 'evento' pelo @Output FTA.
    aoAdicionarEventoCompleto(eventoAdicionado) {
        this.eventos = eventoAdicionado;
        this.fta.eventos = this.eventos;
    }

    validaFta(fta: FTA) {

    }

    // Salva/Edita o FTA completo
    salvar() {
        if (!this.validacaoService.validaFta(this.fta)) {
            return;
        }

        for (let i in this.fta.eventos) {
            if (this.fta.eventos[i].codTipoEvento == 1) {
                this.fta.eventos[i].detalheEventoProcessamento = null;
                this.fta.eventos[i].detalheEventoOperacao = null;
            } else if (this.fta.eventos[i].codTipoEvento == 2) {
                this.fta.eventos[i].detalheEventoProcessamento = null;
                this.fta.eventos[i].detalheEventoTransmissao = null;
            } else {
                this.fta.eventos[i].detalheEventoTransmissao = null;
                this.fta.eventos[i].detalheEventoOperacao = null;
            }
        }

        if (this.date) {
            let dia = this.date.getDate();
            let mes = this.date.getMonth() + 1;
            let ano = this.date.getUTCFullYear();
            let dt: string = dia + '/' + mes + '/' + ano;
            this.fta.validade = dt;
        }

        //edicao ou copia
        if (this.codigoFTA > 0) {
            //Caso seja uma copia de fta limpa a versao e o numero do fta.
            if (this.isCopiaFTA == 'S') {
                this.fta.fta = 0;
                this.fta.versao = 0;
                this.salvarFta();

                //edicao
            } else {
                this.fta.fta = this.codigoFTA;
                this.fta.versao = 0;

                var valueConfirm = '';

                this.modalService
                    .abrirPaginaModal(
                        'confirmar-fta-modal',
                        {},
                        {},
                        'Atualizar FTA',
                        'Fechar'
                    )
                    .subscribe((resp) => {
                        this.fta.msgHistoricoInclusaoFta = resp.msgHistoricoInclusaoFta;

                        if (resp.versao == 'same') {
                            this.fta.versao = this.versaoFTA;
                        }

                        this.salvarFta();
                    });
            }

            //novo fta
        } else {
            if (this.fta.eventos.length == 0) {
                this.validaEventoFta();
                return;
            }

            // this.fta.fta = 0
            this.fta.versao = 0;
            if (this.fta.fta == undefined) {
                this.fta.fta = 0;
            }
            //this.fta.codModelo = 0
            this.salvarFta();
        }
    }

    validaEventoFta() {
        var valueConfirm = '';
        $.confirm({
            title: 'Atenção!',
            content: 'Favor preencher os dados do(s) evento(s).',
            type: 'red',
            buttons: {
                sameVersion: {
                    text: 'Ok',
                    action: function () {
                        valueConfirm = 'same';
                    },
                },
            },
        });
    }

    // método usado para salvar FTA
    salvarFta() {

        this.globalService.loading = true;

        this.fta.eventos.map((evento) => {
            delete evento.listaParametrosSelecionados;
            delete evento.listaParametrosSelecionadosOperacao;
            delete evento.parametrosSelecionados;
            delete evento.parametrosSelecionadosOperacao;
        });

        this.catalogoApi
            .criaEditaFta(this.fta.fta, this.fta.versao, this.fta)
            .subscribe(
                (resposta) => {
                    let numFtaSalvo = resposta.codigoCriado;
                    let versaoFtaSalvo = resposta.versaoCriada;
                    let estado: any = this.getEstado(resposta.codEstadoAtual);
                    this.exibirMensagemSucesso(
                        `FTA nº ${numFtaSalvo} gravado com sucesso. <br>Estado: '${estado.descricao}'.`
                    );
                    this.globalService.loading = false;
                    return false;
                },
                (erro) => {
                    this.globalService.loading = false;
                    //this.messageService.addError(`Erro ao salvar o Fta.`);
                    this.exibirMensagemErro(`Erro ao salvar o FTA. \n ${erro.error.mensagem}`);
                    return false;
                }
            );
    }

    exibirMensagemSucesso(msgTxt: string) {
        $.confirm({
            title: 'Sucesso!',
            content: msgTxt,
            type: 'green',
            buttons: {
                ok: {
                    btnClass: 'btn-blue',
                },
            },
            onClose: () => {
                // if(this.fta.fta == 0){
                //   this.router.navigate(['/fluxo-cliente-interno-completo', "reload"]);
                // }
                this.navegarParaHome();
            },
        });
    }

    exibirMensagemErro(msgTxt: string) {
        $.confirm({
            title: 'Erro!',
            content: msgTxt,
            type: 'red',
            buttons: {
                ok: {
                    btnClass: 'btn-blue',
                },
            },
        });
    }

    navegarParaHome() {
        this.router.navigate(['/catalogo']);
    }

    onFormularioSubmit(formulario: NgForm) {
    }

    isDisabled(index): boolean {
        if (Number(index) == 0) {
            return true;
        } else {
            return false;
        }
    }

    verificaFta() {
        if (this.fta.fta != null && this.fta.fta != 0) {
            this.catalogoApi.verificarExistenciaFta(this.fta.fta).subscribe(
                (sucesso) => {
                    let retorno = sucesso.ftas;
                    if (retorno.length > 0) {
                        this.exibirMensagemErro(
                            `FTA nº ${this.fta.fta} já foi cadastrado!`
                        );
                        this.fta.fta = null;
                    }
                },
                () => {
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/fluxo-cliente-interno-completo/fluxo-cliente-interno-completo.ts